import React from "react";
import * as Select from "@radix-ui/react-select";
import { AHIcon, Box, useLayoutContext, useTheme } from "arkh";
import styles from "./OrgSelector.module.css";

export function OrgSelector<T extends string>(props: {
  selectedValue: T;
  onValueChange: (v: T) => void;
  disabled?: boolean;
  options: T[];
  renderValue: (v: T) => React.ReactNode;
  renderOption: (v: T) => React.ReactNode;
}) {
  const layout = useLayoutContext();
  const theme = useTheme();

  return (
    <Select.Root
      value={props.selectedValue}
      disabled={props.disabled}
      onValueChange={(v) => {
        if (!props.disabled) {
          props.onValueChange(v as T);
        }
      }}
    >
      <Select.Trigger
        className={styles.Trigger + " "}
        disabled={props.disabled}
        style={{
          cursor: props.disabled ? "default" : "pointer",

          borderWidth: 1,
          borderStyle: "solid",
          backgroundColor: props.disabled
            ? "transparent"
            : theme["surface-primary"],
          borderColor: theme["border-primary"],
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: layout.radius.medium,
          paddingLeft: layout.space.small,
          paddingRight: layout.space.small,
          lineHeight: 1,
          height: 30,
        }}
      >
        <Select.Value>
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",

              flex: 1,
            }}
          >
            {props.renderValue(props.selectedValue)}
          </Box>
        </Select.Value>
      </Select.Trigger>

      <Select.Portal>
        <Select.Content
          style={{
            cursor: "pointer",
            overflow: "hidden",
            backgroundColor: theme.surface,
            borderRadius: layout.radius.medium,
            zIndex: 999999,
            boxShadow:
              "0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)",
          }}
        >
          <Select.ScrollUpButton>
            <Box
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
              spaceTop="xsmall"
            >
              <AHIcon type="chevron-up" />
            </Box>
          </Select.ScrollUpButton>
          <Select.Viewport>
            {props.options.map((p) => (
              <Select.Item
                key={p}
                value={p}
                className={styles.SelectItem}
                style={{
                  fontSize: 13,
                  lineHeight: 1,

                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  padding: "15px 20px 15px 20px",
                  position: "relative",
                  userSelect: "none",
                  zIndex: 999999,
                }}
              >
                <Box style={{ flex: 1 }}>{props.renderOption(p)}</Box>
                <Select.ItemIndicator />
              </Select.Item>
            ))}

            <Select.Separator />
          </Select.Viewport>
          <Select.ScrollDownButton>
            <Box
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
              spaceTop="xsmall"
            >
              <AHIcon type="chevron-down" />
            </Box>
          </Select.ScrollDownButton>
          <Select.Arrow />
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
}
